export enum ConsultantPipelineStatus {
  NotPlaced = "NotPlaced",
  NotRelevant = "NotRelevant",
  RelevantInTheFuture = "RelevantInTheFuture",
  Warm = "Warm",
  RelevantNow = "RelevantNow",
  ReadyToBePresented = "ReadyToBePresented",
  Presented = "Presented",
  Booked = "Booked"
}
